import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fl mt20 text-left w100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl",
  style: {}
}, "確定または完了時にファイルダウンロード", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "確定時：")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "w100"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "w80 fl" }
const _hoisted_9 = { class: "w20 fl" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "mt20 ml10"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: `auto_download_`,
  class: "fs13 pointer"
}, "完了・確定時に自動でダウンロードを開始", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { class: "mt20" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "完了時：", -1)
const _hoisted_16 = {
  key: 0,
  class: "w100"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "w80 fl" }
const _hoisted_20 = { class: "w20 fl" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserFileImage = _resolveComponent("UserFileImage")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_FileBoardModal = _resolveComponent("FileBoardModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", null, [
      _hoisted_4,
      (_ctx.Util.isBlank(_ctx.fixAttachmentFiles))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("label", {
              class: "skyblueBg rad8 pointer fw600",
              style: {"padding":"8px 14px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showImageBoardModal(`fix`)))
            }, " ファイルを選択 "),
            _hoisted_6
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_UserFileImage, {
                file: _ctx.fixAttachmentFiles[0],
                showDeleteButton: false,
                type: `form`,
                hideToolTip: false,
                hideDownloadLink: true,
                class: ""
              }, null, 8, ["file"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", {
                class: "circle_button fw600 fl centered fs11 lgreyBg",
                style: {
                            width: `100px`,
                            padding: `4px 10px`,
                        },
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteFiles(_ctx.fixAttachmentFiles[0], `fix`)))
              }, " 削除 "),
              _createElementVNode("label", {
                class: "circle_button fw600 fl centered fs11 blueAround",
                style: {
                            width: `100px`,
                            padding: `4px 10px`,
                        },
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeAttachment(`fix`)))
              }, " ファイルを変更 ")
            ]),
            _hoisted_10,
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_CheckboxTag, {
                    value: ``,
                    name: `auto_download`,
                    checked: _ctx.rcm.room_setting.can_auto_download,
                    prefix: `auto_download`,
                    onClickCheckbox: _ctx.clickAutoDownloadFiles,
                    style: {"margin-left":"1px","margin-right":"7px"}
                  }, null, 8, ["checked", "onClickCheckbox"]),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true)
          ])),
      _hoisted_13
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      (_ctx.Util.isBlank(_ctx.inquireAttachmentFiles))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("label", {
              class: "skyblueBg rad8 pointer fw600",
              style: {"padding":"8px 14px"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showImageBoardModal(`inquire`)))
            }, " ファイルを選択 "),
            _hoisted_17
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_UserFileImage, {
                file: _ctx.inquireAttachmentFiles[0],
                showDeleteButton: false,
                type: `form`,
                hideToolTip: false,
                hideDownloadLink: true,
                class: ""
              }, null, 8, ["file"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", {
                class: "circle_button fw600 fl centered fs11 lgreyBg",
                style: {
                            width: `100px`,
                            padding: `4px 10px`,
                        },
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteFiles(_ctx.inquireAttachmentFiles[0], `inquire`)))
              }, " 削除 "),
              _createElementVNode("label", {
                class: "circle_button fw600 fl centered fs11 blueAround",
                style: {
                            width: `100px`,
                            padding: `4px 10px`,
                        },
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeAttachment(`inquire`)))
              }, " ファイルを変更 ")
            ]),
            _hoisted_21
          ])),
      _hoisted_22
    ]),
    _createVNode(_component_FileBoardModal, {
      class: _normalizeClass(`posAb`),
      currentFiles: _ctx.currentFiles,
      title: `ファイルを選択`,
      onSelect: _ctx.selectFile,
      onDeleteFiles: _ctx.deleteFiles
    }, null, 8, ["currentFiles", "onSelect", "onDeleteFiles"])
  ]))
}